
require('angular').module('clientDashboardApp.reviewBuilder')
  .directive('templateDocsViewer', ["$uibModal", "providerService", "userService", function($uibModal, providerService, userService) {

  function loadProviders() {
    return userService.currentUser().then(user => {
      return providerService.validProviders("all-" + user.username, providerService.TYPE_REVIEWS).then(providers => {
        return providers
          .filter(p => p.providerSettings.publicProvider && p.providerSettings.reviewBuilderAllowed)
          .map(p => p.id.toLowerCase())

      })
    })
  }


  function showModal() {
    $uibModal.open({
      template: require('./templateDocs.html'),
      size: 'lg',
      controller: ["$scope", function($scope) {
        loadProviders().then(providers => {
          $scope.providers = providers;
        })
      }]
    })
  }

  return {
    scope: 'A',
    link: function(scope, element) {
      element.on('click', showModal)
    }
  }
}])
